import { buildFetchOptionsWithAuth, useMutation } from '@fv/client-core'

async function fetchFile(uri: string): Promise<Blob> {
  const options = buildFetchOptionsWithAuth()
  const response = await fetch(uri, options)

  return await response.blob()
}

export function useAuthenticatedFileDownload(uri: string) {
  return useMutation({
    mutationKey: ['file-download', uri],
    mutationFn: () => fetchFile(uri),
  })
}
